import { FunctionComponent, useEffect, useState } from "react";
import styled from "styled-components";
import Text from "../../Text";
import SvgFragment from "../../../fragments/SvgFragment";
import { ReactComponent as NewFeedGuide } from "../../../assets/img/feed/newFeedGuide.svg";

interface ICreateFeedGuideModalProps {
  onClose?: () => void;
}

const CreateFeedGuideModal: FunctionComponent<ICreateFeedGuideModalProps> = ({
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger fade-in animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <Backdrop onClick={handleBackdropClick} $isVisible={isVisible}>
      <Container $isVisible={isVisible}>
        <Header>
          <Text $heading3>How to create custom feed</Text>
          <X onClick={() => onClose?.()}>
            <SvgFragment type="close" />
          </X>
        </Header>
        <DescriptionSection>
          <Text $paragraph2>
            It only takes three steps to create a custom feed: pick your contacts,
            create your feed, and start engaging.
          </Text>
        </DescriptionSection>
        <ImageContainer>
          <NewFeedGuide />
        </ImageContainer>
      </Container>
    </Backdrop>
  );
};

const Backdrop = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

const Container = styled.div<{ $isVisible: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 793px;
  height: 456px;
  border-radius: 4px;
  padding: 32px 24px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transform: ${({ $isVisible }) => ($isVisible ? 'scale(1)' : 'scale(0.9)')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: all 0.5s ease-in-out;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  position: relative;
`;

const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;
  padding: 24px 0px 8px;
`;

const X = styled.div`
  position: absolute;
  right: 20px;
  cursor: pointer;

  & .svg {
    height: 24px;
    width: 24px;
  }
`;

export default CreateFeedGuideModal;
